import React, { memo, useCallback } from 'react';
import { IconChevronDown } from '@adc/parallax-component-library';
import { Input } from 'Components/utility';
const SelectorInput = memo(({ onClick, testID, ...rest }) => {
    const onEventStart = useCallback(() => {
        onClick();
    }, [onClick]);
    return (React.createElement(Input, { testID: testID, editable: false, onBlur: onEventStart, onFocus: onEventStart, inlineIconConfig: {
            color: '$interactive.tertiary.enabled.onColor',
            'aria-label': 'Select',
            icon: (React.createElement(IconChevronDown, { testID: `${testID}-arrowDown-btn`, color: "$interactive.tertiary.enabled.onColor" })),
        }, ...rest }));
});
SelectorInput.displayName = 'SelectorInput';
export { SelectorInput };
